import _toConsumableArray from "/codebuild/output/src1212613480/src/somos.regenera.pe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { Chart, registerables } from '../dist/chart.mjs';
Chart.register.apply(Chart, _toConsumableArray(registerables));
export default Chart;